<template>
  <div class="row">
    <div id="pagination" class="col-12 mt-2">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li :class="{ disabled: isFirst }" class="page-item" @click="loadPage(0)">
            <a class="page-link">First</a>
          </li>
          <li :class="{ disabled: isPreviousDisabled }" class="page-item">
            <span class="page-link" @click.prevent="loadPrevPage">Previous</span>
          </li>
          <li
              v-for="n in totalPages"
              v-show="showTab(n - 1)"
              :key="n"
              :class="{ active: ( n - 1 ) === currentPage }"
              class="page-item"
              @click="loadPage(n - 1)"
          >
            <span class="page-link">{{ n }}</span>
          </li>
          <li :class="{ disabled: isNextDisabled }" class="page-item">
            <span class="page-link" @click.prevent="loadNextPage">Next</span>
          </li>
          <li :class="{ disabled: isLast }" class="page-item" @click="loadPage(lastPage)">
            <span class="page-link">Last</span>
          </li>
        </ul>
      </nav>
    </div>
    <div class="col-12 mt-2">
      <p>Showing page {{ displayPage }} of {{ displayTotal }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "paginator",
  props: {
    callback: {
      type: Function,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    pages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 3
    }
  },
  computed: {
    // `page` is zero-based, `pages` is a count: the last valid page is pages - 1.
    currentPage() {
      return this.page;
    },
    totalPages() {
      return this.pages;
    },
    lastPage() {
      return Math.max(0, this.totalPages - 1);
    },
    // Page numbers are shown from 1 even though paging is zero-based.
    displayPage() {
      return this.currentPage + 1;
    },
    displayTotal() {
      return Math.max(this.totalPages, 1);
    },
    isPreviousDisabled() {
      return this.currentPage <= 0;
    },
    isNextDisabled() {
      return this.currentPage >= this.lastPage;
    },
    isFirst() {
      return this.currentPage === 0;
    },
    isLast() {
      return this.currentPage >= this.lastPage;
    }
  },
  methods: {
    loadPage(p) {
      if (p >= 0 && p <= this.lastPage && p !== this.currentPage) {
        this.callback(p);
      }
    },
    loadPrevPage() {
      if (!this.isPreviousDisabled) {
        this.loadPage(this.currentPage - 1);
      }
    },
    loadNextPage() {
      if (!this.isNextDisabled) {
        this.loadPage(this.currentPage + 1);
      }
    },
    showTab(n) {
      const left = Math.max(this.currentPage - this.perPage, 0);
      const right = Math.min(this.currentPage + this.perPage, this.lastPage);
      return n >= left && n <= right;
    }
  }
};
</script>
